import { apiHolder as api, apis } from 'api';
import { FLOLDER, MAIL_SORT_ITEM, redFlagStr, unReadStr, orderByDateDescStr, orderByDateAscStr, orderBySenderCapDescStr, orderBySenderCapAscStr, orderByReceiverCapDescStr, orderByReceiverCapAscStr, orderBySubjectCapDescStr, orderBySubjectCapAscStr, orderBySizeCapDescStr, orderBySizeCapAscStr, onStr, deferStr, myCustomerStr, attachmentStr, } from '@web-mail/common/constant';
import { mailConfigStateIsMerge, folderIdIsContact, folderIdIsAllFolder, folderIdIsAllFolderSubAccount, folderIdIsAllReceiveFolder, folderIdIsAllSentFolder, } from '@web-mail/util';
import { getIn18Text } from 'api';
import { folderIdIsAllCustomerUnFollow, folderIdIsAllUnFollow } from '@web-mail/utils/folder';
export const allReadConditionList = [MAIL_SORT_ITEM.UNREAD, MAIL_SORT_ITEM.ORDER_BY_DATE_DESC, MAIL_SORT_ITEM.ORDER_BY_DATE_ASC];
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const systemApi = api.api.getSystemApi();
const unifyFolderList = [FLOLDER.DEFAULT, FLOLDER.SPAM, FLOLDER.ADVITISE, FLOLDER.DELETED, FLOLDER.READYISSUE, FLOLDER.WAITINGISSUE];
const getShouldShowReceiverSeenFilter = (folderId, account) => {
    return (process.env.BUILD_ISEDM &&
        mailConfApi.getShowReceiverSeenFilter(account) &&
        (folderId === FLOLDER.SENT || (folderIdIsAllSentFolder(folderId) && folderIdIsAllFolderSubAccount(folderId))));
};
const CUSTOMIZE_SORT_COMMON_LIST = [
    MAIL_SORT_ITEM.REDFLAG,
    MAIL_SORT_ITEM.UNREAD,
    MAIL_SORT_ITEM.MY_CUSTOMER,
    MAIL_SORT_ITEM.ORDER_BY_DATE_DESC,
    MAIL_SORT_ITEM.ORDER_BY_DATE_ASC,
    MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_DESC,
    MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_ASC,
    MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_DESC,
    MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_ASC,
    MAIL_SORT_ITEM.ORDER_BY_SIZE_DESC,
    MAIL_SORT_ITEM.ORDER_BY_SIZE_ASC,
];
const CUSTOMIZE_SORT_THREAD_LIST = [MAIL_SORT_ITEM.REDFLAG, MAIL_SORT_ITEM.UNREAD];
const FLOLDER_SORT_COMMON_MAP = {
    [MAIL_SORT_ITEM.REDFLAG]: [...unifyFolderList],
    [MAIL_SORT_ITEM.UNREAD]: [...unifyFolderList, FLOLDER.EDM_REPLY, FLOLDER.EDM_OTHER_REPLY],
    [MAIL_SORT_ITEM.MY_CUSTOMER]: [FLOLDER.DEFAULT, FLOLDER.SENT, FLOLDER.UNREAD, FLOLDER.READYISSUE, FLOLDER.WAITINGISSUE],
    [MAIL_SORT_ITEM.ORDER_BY_DATE_DESC]: [...unifyFolderList, FLOLDER.SENT, FLOLDER.REDFLAG, FLOLDER.TAG, FLOLDER.DRAFT, FLOLDER.DEFER],
    [MAIL_SORT_ITEM.ORDER_BY_DATE_ASC]: [...unifyFolderList, FLOLDER.SENT, FLOLDER.REDFLAG, FLOLDER.TAG, FLOLDER.DRAFT, FLOLDER.DEFER],
    [MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_DESC]: [...unifyFolderList],
    [MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_ASC]: [...unifyFolderList],
    [MAIL_SORT_ITEM.ORDER_BY_RECEIVER_CAPITAL_DESC]: [FLOLDER.SENT, FLOLDER.DRAFT],
    [MAIL_SORT_ITEM.ORDER_BY_RECEIVER_CAPITAL_ASC]: [FLOLDER.SENT, FLOLDER.DRAFT],
    [MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_DESC]: [...unifyFolderList, FLOLDER.SENT, FLOLDER.DRAFT],
    [MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_ASC]: [...unifyFolderList, FLOLDER.SENT, FLOLDER.DRAFT],
    [MAIL_SORT_ITEM.ORDER_BY_SIZE_DESC]: [...unifyFolderList, FLOLDER.SENT, FLOLDER.DRAFT],
    [MAIL_SORT_ITEM.ORDER_BY_SIZE_ASC]: [...unifyFolderList, FLOLDER.SENT, FLOLDER.DRAFT],
    [MAIL_SORT_ITEM.ON]: [FLOLDER.TASK],
    [MAIL_SORT_ITEM.DEFER]: [FLOLDER.DEFER],
    [MAIL_SORT_ITEM.SENT]: [FLOLDER.STAR],
    [MAIL_SORT_ITEM.RECEIVED]: [FLOLDER.STAR],
};
const FLOLDER_SORT_THREAD_MAP = {
    [MAIL_SORT_ITEM.REDFLAG]: [...unifyFolderList],
    [MAIL_SORT_ITEM.UNREAD]: [...unifyFolderList, FLOLDER.EDM_REPLY, FLOLDER.EDM_OTHER_REPLY],
    [MAIL_SORT_ITEM.ON]: [FLOLDER.TASK],
    [MAIL_SORT_ITEM.DEFER]: [FLOLDER.DEFER],
    [MAIL_SORT_ITEM.SENT]: [FLOLDER.STAR],
    [MAIL_SORT_ITEM.RECEIVED]: [FLOLDER.STAR],
};
const judgeShow = (type, folderId) => {
    var _a;
    const isThreadMode = mailConfApi.getMailMergeSettings() === 'true';
    if (folderIdIsContact(folderId) && (type == MAIL_SORT_ITEM.RECEIVED || type == MAIL_SORT_ITEM.SENT)) {
        return true;
    }
    if (typeof folderId == 'number') {
        if (isThreadMode) {
            return folderId >= 100 ? CUSTOMIZE_SORT_THREAD_LIST.includes(type) : !!((_a = FLOLDER_SORT_THREAD_MAP[type]) === null || _a === void 0 ? void 0 : _a.includes(folderId));
        }
        return folderId >= 100 ? CUSTOMIZE_SORT_COMMON_LIST.includes(type) : FLOLDER_SORT_COMMON_MAP[type].includes(folderId);
    }
    return false;
};
const DefaultMailSortConfig = {
    [MAIL_SORT_ITEM.REDFLAG]: {
        key: MAIL_SORT_ITEM.REDFLAG,
        level: 1,
        sort: 1,
        name: redFlagStr,
        tabName: getIn18Text('HONGQI'),
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.REDFLAG, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.UNREAD]: {
        key: MAIL_SORT_ITEM.UNREAD,
        level: 1,
        sort: 2,
        name: unReadStr,
        tabName: getIn18Text('WEIDU'),
        show: folderId => {
            if (folderIdIsAllReceiveFolder(folderId)) {
                return true;
            }
            return judgeShow(MAIL_SORT_ITEM.UNREAD, folderId) || folderIdIsContact(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ATTACHMENT]: {
        key: MAIL_SORT_ITEM.ATTACHMENT,
        level: 1,
        sort: 2,
        name: attachmentStr,
        tabName: getIn18Text('HANFUJIAN'),
        needDivider: true,
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.REDFLAG, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.MY_CUSTOMER]: {
        key: MAIL_SORT_ITEM.MY_CUSTOMER,
        level: 1,
        sort: 3,
        name: myCustomerStr,
        tabName: getIn18Text('WODEKEHU'),
        needDivider: true,
        show: folderId => {
            return (process.env.BUILD_ISEDM &&
                mailConfApi.getShowCustomerTab() &&
                !mailConfigStateIsMerge() &&
                !folderIdIsContact(folderId) &&
                judgeShow(MAIL_SORT_ITEM.MY_CUSTOMER, folderId));
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.RECEIVER_READ]: {
        key: MAIL_SORT_ITEM.RECEIVER_READ,
        level: 1,
        sort: 4,
        name: getIn18Text('MAIL_RECEIVER_READ'),
        tabName: getIn18Text('MAIL_RECEIVER_READ'),
        needDivider: true,
        show: (folderId, _fn, account) => {
            return mailConfApi.getMailPageLayout() !== '1' && getShouldShowReceiverSeenFilter(folderId, account);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.RECEIVER_READ_TAB]: {
        key: MAIL_SORT_ITEM.RECEIVER_READ,
        level: 3,
        sort: 1,
        name: getIn18Text('MAIL_RECEIVER_READ'),
        tabName: getIn18Text('MAIL_RECEIVER_READ'),
        needDivider: true,
        show: (folderId, _fn, account) => {
            return mailConfApi.getMailPageLayout() === '1' && getShouldShowReceiverSeenFilter(folderId, account);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.RECEIVER_UNREAD]: {
        key: MAIL_SORT_ITEM.RECEIVER_UNREAD,
        level: 1,
        sort: 5,
        name: getIn18Text('MAIL_RECEIVER_UNREAD'),
        tabName: getIn18Text('MAIL_RECEIVER_UNREAD'),
        needDivider: true,
        show: (folderId, _fn, account) => {
            return mailConfApi.getMailPageLayout() !== '1' && getShouldShowReceiverSeenFilter(folderId, account);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.RECEIVER_UNREAD_TAB]: {
        key: MAIL_SORT_ITEM.RECEIVER_UNREAD,
        level: 3,
        sort: 2,
        name: getIn18Text('MAIL_RECEIVER_UNREAD'),
        tabName: getIn18Text('MAIL_RECEIVER_UNREAD'),
        needDivider: true,
        show: (folderId, _fn, account) => {
            return mailConfApi.getMailPageLayout() === '1' && getShouldShowReceiverSeenFilter(folderId, account);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ORDER_BY_DATE_DESC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_DATE_DESC,
        level: 2,
        sort: 3,
        name: orderByDateDescStr,
        show: folderId => {
            if (folderIdIsAllFolder(folderId) && !folderIdIsAllCustomerUnFollow(folderId) && !folderIdIsAllUnFollow(folderId)) {
                return true;
            }
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_DATE_DESC, folderId);
        },
        onClick: () => { },
        default: true,
    },
    [MAIL_SORT_ITEM.ORDER_BY_DATE_ASC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_DATE_ASC,
        level: 2,
        sort: 4,
        name: orderByDateAscStr,
        show: folderId => {
            if (folderIdIsAllFolder(folderId) && !folderIdIsAllCustomerUnFollow(folderId) && !folderIdIsAllUnFollow(folderId)) {
                return true;
            }
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_DATE_ASC, folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_DESC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_DESC,
        level: 2,
        sort: 5,
        name: orderBySenderCapDescStr,
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_DESC, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_ASC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_ASC,
        level: 2,
        sort: 6,
        name: orderBySenderCapAscStr,
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_SENDER_CAPITAL_ASC, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ORDER_BY_RECEIVER_CAPITAL_DESC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_RECEIVER_CAPITAL_DESC,
        level: 2,
        sort: 5,
        name: orderByReceiverCapDescStr,
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_RECEIVER_CAPITAL_DESC, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ORDER_BY_RECEIVER_CAPITAL_ASC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_RECEIVER_CAPITAL_ASC,
        level: 2,
        sort: 6,
        name: orderByReceiverCapAscStr,
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_RECEIVER_CAPITAL_ASC, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_DESC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_DESC,
        level: 2,
        sort: 7,
        name: orderBySubjectCapDescStr,
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_DESC, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_ASC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_ASC,
        level: 2,
        sort: 8,
        name: orderBySubjectCapAscStr,
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_SUBJECT_CAPITAL_ASC, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ORDER_BY_SIZE_DESC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_SIZE_DESC,
        level: 2,
        sort: 9,
        name: orderBySizeCapDescStr,
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_SIZE_DESC, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ORDER_BY_SIZE_ASC]: {
        key: MAIL_SORT_ITEM.ORDER_BY_SIZE_ASC,
        level: 2,
        sort: 10,
        name: orderBySizeCapAscStr,
        show: folderId => {
            return !mailConfigStateIsMerge() && judgeShow(MAIL_SORT_ITEM.ORDER_BY_SIZE_ASC, folderId) && !folderIdIsAllFolder(folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.ON]: {
        key: MAIL_SORT_ITEM.ON,
        level: 1,
        sort: 1,
        name: onStr,
        show: folderId => {
            return judgeShow(MAIL_SORT_ITEM.ON, folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.DEFER]: {
        key: MAIL_SORT_ITEM.DEFER,
        level: 1,
        sort: 1,
        name: deferStr,
        show: folderId => {
            return judgeShow(MAIL_SORT_ITEM.DEFER, folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.SENT]: {
        key: MAIL_SORT_ITEM.SENT,
        level: 1,
        sort: 1,
        name: getIn18Text('WOFACHUDE'),
        show: folderId => {
            return judgeShow(MAIL_SORT_ITEM.SENT, folderId);
        },
        onClick: () => { },
    },
    [MAIL_SORT_ITEM.RECEIVED]: {
        key: MAIL_SORT_ITEM.RECEIVED,
        level: 1,
        sort: 1,
        needDivider: true,
        name: getIn18Text('WOSHOUDAODE'),
        show: folderId => {
            return judgeShow(MAIL_SORT_ITEM.RECEIVED, folderId);
        },
        onClick: () => { },
    },
};
export default DefaultMailSortConfig;
